import { render, staticRenderFns } from "./PeopleTimesheetList.vue?vue&type=template&id=7dd40480&scoped=true&"
import script from "./PeopleTimesheetList.vue?vue&type=script&lang=js&"
export * from "./PeopleTimesheetList.vue?vue&type=script&lang=js&"
import style0 from "./PeopleTimesheetList.vue?vue&type=style&index=0&id=7dd40480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd40480",
  null
  
)

export default component.exports